// extracted by mini-css-extract-plugin
export var dropdownIcon = "_lh-6";
export var imgContainer = "_lh-3";
export var menuIcon = "_lh-5";
export var pillWrapper = "_lh-2";
export var pillsContainer = "_lh-1";
export var subscriptionCard = "_lh-0";
export var subscriptionLogo = "_lh-4";